import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

const Top = ({}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  const reduce_get_accounts = useSelector((state) => state.reduce_get_accounts);

  return (
    <>
      <div>
        <nav className="navbar navbar-expand-md navbar-light navbar-custom bg-white">
          <div className="container">
            <a
              href="index.html"
              className="navbar-brand"
              onClick={(e) => {
                e.preventDefault();
                history.push({
                  pathname: `/top`,
                });
                window.scroll(0, 0);
              }}
            >
              <img src="images/brand.svg" height={40} alt="SC WORLD EXCHANGE" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <a
                    href="#"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/exch-market`,
                      });
                      window.scroll(0, 0);
                    }}
                  >
                    {t("仮想通貨取引")}
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/pay`,
                      });
                      window.scroll(0, 0);
                    }}
                  >
                    {t("入出金")}
                  </a>
                </li>
                <li className={`nav-item `}>
                  <a
                    href="javascript:void(0);"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      i18n.changeLanguage("ja");
                      sessionStorage.setItem("AcceptLanguage", "ja");
                    }}
                  >
                    <p>{t("日本語")}</p>
                  </a>
                </li>
                <li className={`nav-item `}>
                  <a
                    href="javascript:void(0);"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      i18n.changeLanguage("en");
                      sessionStorage.setItem("AcceptLanguage", "en");
                    }}
                  >
                    <p>{t("英語")}</p>
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a href="#" className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/top`,
                      });
                      window.scroll(0, 0);
                    }}
                  
                  >
                    Help
                  </a>
                </li> */}
              </ul>
              <div className="mt-3 mt-md-0">
                <ul className="navbar-nav mr-auto">
                  <li className="nav-item">
                    <a
                      href="signup.html"
                      className="btn btn-outline-dark btn-pill btn-border-2 d-block d-md-inline-block mr-md-2"
                      onClick={(e) => {
                        e.preventDefault();
                        history.push({
                          pathname: `/signup`,
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      {t("新規登録")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href="signin.html"
                      className="btn btn-outline-primary btn-pill btn-border-2 d-block d-md-inline-block mt-2 mt-md-0"
                      onClick={(e) => {
                        e.preventDefault();
                        history.push({
                          pathname: `/signin`,
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      {t("ログイン")}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href="#"
                      className="nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        history.push({
                          pathname: `/settings`,
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      {reduce_get_accounts ? reduce_get_accounts.mail_address : ""}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <header className="header d-flex align-items-center">
          <div className="container">
            {/* <span style={{ backgroundColor: "yellow", color: "red" }}>
              【メンテナンスのご案内】
              <br />
              いつもSC-World Exchangeをご利用いただきありがとうございます。 <br />
              SC-World
              Exchangeでは、パフォーマンスの向上および安定運用の為下記の日程にてシステムメンテナンスの実施をいたします。
              <br />
              ご不便をおかけしますが、よろしくお願いいたします。
              <br />
              メンテナンス予定日時：2022年9月17日（土）0:00〜2022年9月26日（月）0:00予定
            </span> */}
            <h1>
              {t("はじめての仮想通貨は")}
              <br />
              {t("SCワールドエクスチェンジ")}
            </h1>
            {/* <a
              href="#"
              className="btn btn-outline-light btn-pill btn-border-2 btn-arrow-right btn-lg"
            >
              Whitepaper
            </a> */}
          </div>
        </header>
        <main role="main">
          <section className="section bg-sec-1">
            <div className="container">
              <h2 className="text-right">{t("SCワールドエクスチェンジの特徴")}</h2>
              <p className="lead text-right">
                {t("シンプルモードで仮想通貨をかんたん売買")}
                <br />
                {t("堅牢で高速なシステム")}
                <br />
                {t("本格的なトレードも")}
                <br />
                {t("24時間のサポート体制")}
              </p>
              <h3 className="text-border-both mt-6">{t("SCワールドエクスチェンジの特徴")}</h3>
              <div className="feature row px-lg-5">
                <div className="col-sm-6 col-md-3 text-center mt-5">
                  <p className="box-circle box-circle-scale">
                    <img src="images/sec-1-ic-1.png" width={36} alt />
                  </p>
                  <p className="lead">
                    {t("シンプルモードで仮想通貨をかんたん売買")}
                    <br className="d-none d-sm-inline-block" />
                  </p>
                </div>
                <div className="col-sm-6 col-md-3 text-center mt-5">
                  <p className="box-circle box-circle-scale">
                    <img src="images/sec-1-ic-2.png" width={36} alt />
                  </p>
                  <p className="lead">
                    {t("堅牢で高速なシステム")}
                    <br className="d-none d-sm-inline-block" />
                  </p>
                </div>
                <div className="col-sm-6 col-md-3 text-center mt-5">
                  <p className="box-circle box-circle-scale">
                    <img src="images/sec-1-ic-3.png" width={36} alt />
                  </p>
                  <p className="lead">
                    {t("本格的なトレードも")}
                    <br className="d-none d-sm-inline-block" />
                  </p>
                </div>
                <div className="col-sm-6 col-md-3 text-center mt-5">
                  <p className="box-circle box-circle-scale">
                    <img src="images/sec-1-ic-4.png" width={36} alt />
                  </p>
                  <p className="lead">
                    {t("24時間のサポート体制")}
                    <br className="d-none d-sm-inline-block" />
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="section bg-sec-2">
            <div className="container">
              <h2 className="text-center">
                {t("いつでも安心")}
                <br />
                {t("いつでも安全なセキュリティ")}
              </h2>
              {/* <p className="text-center">
                This project started with a purpose to create its own ecosystem
                called “CryptoHarbor”.
                <br />
                We will create a platform of
                community-and-original-exchange-based-Special-economic-zone
                using CHE as common currency.
                <br />
                By activating our community, we will make a
                special-economic-zone
                <br />
                where original products and services is born from every
                participant and be shared to the world.
              </p> */}
              <div className="card-deck phase">
                <div className="card">
                  <div className="box-circle box-circle-scale bg-white text-blue">
                    <span>{t("特徴１")}</span>
                  </div>
                  <div className="card-header d-flex flex-column justify-content-center align-items-center">
                    <h3>{t("コールドウォレット")}</h3>
                    <span className="lead"></span>
                  </div>
                  <div className="card-body">
                    {t(
                      "ネットワークにつながっていない場所に資産を保管しているため、堅牢性の高いセキュリティが担保されてます。"
                    )}{" "}
                    <br />
                    {/* <small>
                      Currently our community is taking place in existed
                      services like Discord,Twitter,Bitcointalk.
                      <br />
                      To encourage and bring more freedom to the community, we
                      will establish CryptoHarbor BBS.
                    </small> */}
                  </div>
                </div>
                <div className="card">
                  <div className="box-circle box-circle-scale bg-white text-blue">
                    <span>{t("特徴２")}</span>
                  </div>
                  <div className="card-header d-flex flex-column justify-content-center align-items-center">
                    <h3>{t("システム監査")}</h3>
                  </div>
                  <div className="card-body">
                    {t(
                      "国内外の複数の情報セキュリティ企業等を通して、情報システムの信頼性、安全性、効率性が保たれていることを確認しています。"
                    )}{" "}
                    <br />
                    {/* <small>
                      We will give an advantage of having CHE as Exchange token
                      by creating our own exchange.
                      <br />
                      In this phase we expect to have a leap in liquidity.
                      <br />
                      Also CHE will start to be distributed to the community
                      more smoothly through bounties.
                    </small> */}
                  </div>
                </div>
                <div className="card">
                  <div className="box-circle box-circle-scale bg-white text-blue">
                    <span>{t("特徴３")}</span>
                  </div>
                  <div className="card-header d-flex flex-column justify-content-center align-items-center">
                    <h3>{t("2段階認証")}</h3>
                  </div>
                  <div className="card-body">
                    {t(
                      "ご利用にはメールアドレスとパスワードによる認証に加え、ご自身のスマートフォンを利用した2段階認証が必要なため、第三者は容易にアクセスできません。"
                    )}{" "}
                    <br />
                    {/* <small>
                      We will establish a place where anyone can learn about
                      cryptocurrency and blockchain.
                      <br />
                      By creating a place where knowledge is shared among the
                      participants, we will make projects easier to be born and
                      supported by the community.
                    </small> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mx-auto">
                <div className="row">
                  <div className="col brand-footer">
                    <a
                      href="index.html"
                      onClick={(e) => {
                        e.preventDefault();
                        history.push({
                          pathname: `/top`,
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      <img src="images/brand.svg" className="img-fluid" alt="SC WORLD EXCHANGE" />
                    </a>
                  </div>
                  <div className="col mt-3 mt-md-0">
                    <dl className="nav flex-column">
                      <dt>
                        <b className="text-blue">{t("サービス")}</b>
                      </dt>
                      <dd>
                        <a
                          href="#"
                          className="nav-link"
                          onClick={(e) => {
                            e.preventDefault();
                            history.push({
                              pathname: `/exch-market`,
                            });
                            window.scroll(0, 0);
                          }}
                        >
                          {t("仮想通貨取引")}
                        </a>
                      </dd>
                      <dd>
                        <a
                          href="#"
                          className="nav-link"
                          onClick={(e) => {
                            e.preventDefault();
                            history.push({
                              pathname: `/pay`,
                            });
                            window.scroll(0, 0);
                          }}
                        >
                          {t("入出金")}
                        </a>
                      </dd>
                    </dl>
                  </div>
                  <div className="col mt-3 mt-md-0">
                    <dl className="nav flex-column">
                      <dt>
                        <b className="text-blue">{t("サポート")}</b>
                      </dt>
                      <dd>
                        <a
                          href="#"
                          className="nav-link"
                          onClick={(e) => {
                            e.preventDefault();
                            history.push({
                              pathname: `/contact`,
                            });
                            window.scroll(0, 0);
                          }}
                        >
                          {t("お問い合わせ")}
                        </a>
                      </dd>

                      <dd>
                        <a
                          href="#"
                          className="nav-link"
                          onClick={(e) => {
                            e.preventDefault();
                            history.push({
                              pathname: `/tos`,
                            });
                            window.scroll(0, 0);
                          }}
                        >
                          {t("利用規約")}
                        </a>
                      </dd>
                      {/* <dd>
                        <a
                          href="#"
                          className="nav-link"
                          onClick={(e) => {
                            e.preventDefault();
                            history.push({
                              pathname: `/privacy`,
                            });
                            window.scroll(0, 0);
                          }}
                        >
                          {t("プライバシーポリシー")}
                        </a>
                      </dd> */}
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-footer">
            <div className="container">
              <div className="d-lg-flex justify-content-between">
                <span>© SC WORLD EXCHANGE</span>
                <ul className="list-unstyled d-flex mb-0">
                  {/* <li>
                    2018-10-18 16:45:03 24h Volume: 413,031.18 BNB / 75,352.71
                    BTC / 201,880.02 ETH / 404,871,198.54 USDT
                  </li>
                  <li className="signal">
                    <span className="text-uppercase text-nowrap">
                      <span className="d-none d-sm-inline-block">
                        Connected 
                      </span>
                      <i className="fas fa-wifi text-blue" />
                    </span>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Top;

// <section className="section bg-white">
// <div className="container">
//   <div className="row justify-content-between align-items-center">
//     <div className="col">
//       <a className="ml-2" href="javascript:void(0);">
//         <i className="far fa-star" />
//       </a>
//     </div>
//     <div className="col-sm-4 col-md-3 text-right">
//       <input
//         type="search"
//         className="form-control form-control-pill font-awesome"
//         placeholder="\uF002 Search..."
//       />
//     </div>
//   </div>
//   <div className="table-responsive">
//     <table id="myDataTables" className="table table-hover mt-1">
//       <thead>
//         <tr className="bg-white">
//           <th scope="col"> </th>
//           <th scope="col" className="text-nowrap">
//             通貨ペア
//           </th>
//           <th scope="col" className="text-nowrap">
//             最新価格
//           </th>
//           <th scope="col" className="text-nowrap text-right">
//             24h変化値
//           </th>
//           <th scope="col" className="text-nowrap">
//             24h最高値
//           </th>
//           <th scope="col" className="text-nowrap">
//             24h最安値
//           </th>
//           <th scope="col" className="text-nowrap text-right">
//             24h出来高
//           </th>
//           <th scope="col" className="text-nowrap text-right">
//             チャート
//           </th>
//         </tr>
//       </thead>
//       <tbody>
//         <tr>
//           <td>
//             <a href="javascript:void(0);">
//               <i className="far fa-star" />
//             </a>
//           </td>
//           <td className="text-nowrap">XLM/ETH</td>
//           <td className="text-nowrap">
//             0.0017809{" "}
//             <span className="text-muted">/ 28.23 JPY</span>
//           </td>
//           <td className="text-nowrap text-right">
//             <span className="text-success">4.89 %</span>
//           </td>
//           <td className="text-nowrap">0.00119000</td>
//           <td className="text-nowrap">0.00107543</td>
//           <td className="text-nowrap text-right">
//             35223.76849149 ETH
//           </td>
//           <td className="text-nowrap text-right">
//             <a className="text-info" href="#">
//               <i className="fas fa-chart-line" />
//             </a>
//           </td>
//         </tr>
//         <tr>
//           <td>
//             <a href="javascript:void(0);">
//               <i className="far fa-star" />
//             </a>
//           </td>
//           <td className="text-nowrap">XLM/ETH</td>
//           <td className="text-nowrap">
//             0.0017809{" "}
//             <span className="text-muted">/ 28.23 JPY</span>
//           </td>
//           <td className="text-nowrap text-right">
//             <span className="text-danger">−0.82 %</span>
//           </td>
//           <td className="text-nowrap">0.00119000</td>
//           <td className="text-nowrap">0.00107543</td>
//           <td className="text-nowrap text-right">
//             35223.76849149 ETH
//           </td>
//           <td className="text-nowrap text-right">
//             <a className="text-info" href="#">
//               <i className="fas fa-chart-line" />
//             </a>
//           </td>
//         </tr>
//       </tbody>
//     </table>
//   </div>
// </div>
// </section>
